import { Icon, type IconProps } from '@iconify/react/offline';
import EvaMenuOutline from '@iconify-icons/eva/menu-outline';
import EvaArrowIosBackOutline from '@iconify-icons/eva/arrow-ios-back-outline';
import SolarCalculatorOutline from '@iconify-icons/solar/calculator-outline';
import SolarCartLarge2Outline from '@iconify-icons/solar/cart-large-2-outline';
import SolarHamburgerMenuOutline from '@iconify-icons/solar/hamburger-menu-outline';
import SolarLogoutLineDuotone from '@iconify-icons/solar/logout-line-duotone';
import SolarMoonBold from '@iconify-icons/solar/moon-bold';
import SolarRulerOutline from '@iconify-icons/solar/ruler-outline';
import SolarShieldUserOutline from '@iconify-icons/solar/shield-user-outline';
import SolarSunBold from '@iconify-icons/solar/sun-bold';
import TablerAlertTriangle from '@iconify-icons/tabler/alert-triangle';
import TablerApi from '@iconify-icons/tabler/api';
import TablerArrowsTransferDown from '@iconify-icons/tabler/arrows-transfer-down';
import TablerBellRinging from '@iconify-icons/tabler/bell-ringing';
import TablerBuildingFactory2 from '@iconify-icons/tabler/building-factory-2';
import TablerBuildingStore from '@iconify-icons/tabler/building-store';
import TablerCalculator from '@iconify-icons/tabler/calculator';
import TablerCalendarEvent from '@iconify-icons/tabler/calendar-event';
import TablerCalendarStats from '@iconify-icons/tabler/calendar-stats';
import TablerCalendarTime from '@iconify-icons/tabler/calendar-time';
import TablerCashBanknote from '@iconify-icons/tabler/cash-banknote';
import TablerChartBar from '@iconify-icons/tabler/chart-bar';
import TablerChartHistogram from '@iconify-icons/tabler/chart-histogram';
import TablerChartLine from '@iconify-icons/tabler/chart-line';
import TablerChartPie from '@iconify-icons/tabler/chart-pie';
import TablerCheck from '@iconify-icons/tabler/check';
import TablerChecklist from '@iconify-icons/tabler/checklist';
import TablerClock from '@iconify-icons/tabler/clock';
import TablerCode from '@iconify-icons/tabler/code';
import TablerCoin from '@iconify-icons/tabler/coin';
import TablerCoins from '@iconify-icons/tabler/coins';
import TablerContract from '@iconify-icons/tabler/contract';
import TablerCreditCard from '@iconify-icons/tabler/credit-card';
import TablerCubeSend from '@iconify-icons/tabler/cube-send';
import TablerCurrencyDollar from '@iconify-icons/tabler/currency-dollar';
import TablerEye from '@iconify-icons/tabler/eye';
import TablerEyeDollar from '@iconify-icons/tabler/eye-dollar';
import TablerFileInvoice from '@iconify-icons/tabler/file-invoice';
import TablerFileAnalytics from '@iconify-icons/tabler/file-analytics';
import TablerFileText from '@iconify-icons/tabler/file-text';
import TablerFiles from '@iconify-icons/tabler/files';
import TablerFolder from '@iconify-icons/tabler/folder';
import TablerGift from '@iconify-icons/tabler/gift';
import TablerHistory from '@iconify-icons/tabler/history';
import TablerHome from '@iconify-icons/tabler/home';
import TablerHome2 from '@iconify-icons/tabler/home-2';
import TablerInbox from '@iconify-icons/tabler/inbox';
import TablerLanguage from '@iconify-icons/tabler/language';
import TablerLeaf from '@iconify-icons/tabler/leaf';
import TablerListCheck from '@iconify-icons/tabler/list-check';
import TablerListDetails from '@iconify-icons/tabler/list-details';
import TablerMail from '@iconify-icons/tabler/mail';
import TablerMapPin from '@iconify-icons/tabler/map-pin';
import TablerMessageChatbot from '@iconify-icons/tabler/message-chatbot';
import TablerMoneybag from '@iconify-icons/tabler/moneybag';
import TablerMoon from '@iconify-icons/tabler/moon';
import TablerNotebook from '@iconify-icons/tabler/notebook';
import TablerPackage from '@iconify-icons/tabler/package';
import TablerPlus from '@iconify-icons/tabler/plus';
import TablerReceipt from '@iconify-icons/tabler/receipt';
import TablerReport from '@iconify-icons/tabler/report';
import TablerRobot from '@iconify-icons/tabler/robot';
import TablerSelector from '@iconify-icons/tabler/selector';
import TablerSettings from '@iconify-icons/tabler/settings';
import TablerShieldLock from '@iconify-icons/tabler/shield-lock';
import TablerShip from '@iconify-icons/tabler/ship';
import TablerSun from '@iconify-icons/tabler/sun';
import TablerTag from '@iconify-icons/tabler/tag';
import TablerTemplate from '@iconify-icons/tabler/template';
import TablerTimelineEvent from '@iconify-icons/tabler/timeline-event';
import TablerTool from '@iconify-icons/tabler/tool';
import TablerTrendingUp from '@iconify-icons/tabler/trending-up';
import TablerTruckDelivery from '@iconify-icons/tabler/truck-delivery';
import TablerUsers from '@iconify-icons/tabler/users';
import TablerUsersGroup from '@iconify-icons/tabler/users-group';
import TablerWallet from '@iconify-icons/tabler/wallet';
import TablerWorld from '@iconify-icons/tabler/world';
import TablerWorldDollar from '@iconify-icons/tabler/world-dollar';

// Bundle only the sidebar icons so opening a submenu never fetches icon data.
const sidebarIcons = {
  'eva:menu-outline': EvaMenuOutline,
  'eva:arrow-ios-back-outline': EvaArrowIosBackOutline,
  'solar:calculator-outline': SolarCalculatorOutline,
  'solar:cart-large-2-outline': SolarCartLarge2Outline,
  'solar:hamburger-menu-outline': SolarHamburgerMenuOutline,
  'solar:logout-line-duotone': SolarLogoutLineDuotone,
  'solar:moon-bold': SolarMoonBold,
  'solar:ruler-outline': SolarRulerOutline,
  'solar:shield-user-outline': SolarShieldUserOutline,
  'solar:sun-bold': SolarSunBold,
  'tabler:alert-triangle': TablerAlertTriangle,
  'tabler:api': TablerApi,
  'tabler:arrows-transfer-down': TablerArrowsTransferDown,
  'tabler:bell-ringing': TablerBellRinging,
  'tabler:building-factory-2': TablerBuildingFactory2,
  'tabler:building-store': TablerBuildingStore,
  'tabler:calculator': TablerCalculator,
  'tabler:calendar-event': TablerCalendarEvent,
  'tabler:calendar-stats': TablerCalendarStats,
  'tabler:calendar-time': TablerCalendarTime,
  'tabler:cash-banknote': TablerCashBanknote,
  'tabler:chart-bar': TablerChartBar,
  'tabler:chart-histogram': TablerChartHistogram,
  'tabler:chart-line': TablerChartLine,
  'tabler:chart-pie': TablerChartPie,
  'tabler:check': TablerCheck,
  'tabler:checklist': TablerChecklist,
  'tabler:clock': TablerClock,
  'tabler:code': TablerCode,
  'tabler:coin': TablerCoin,
  'tabler:coins': TablerCoins,
  'tabler:contract': TablerContract,
  'tabler:credit-card': TablerCreditCard,
  'tabler:cube-send': TablerCubeSend,
  'tabler:currency-dollar': TablerCurrencyDollar,
  'tabler:eye': TablerEye,
  'tabler:eye-dollar': TablerEyeDollar,
  'tabler:file-invoice': TablerFileInvoice,
  'tabler:file-analytics': TablerFileAnalytics,
  'tabler:file-text': TablerFileText,
  'tabler:files': TablerFiles,
  'tabler:folder': TablerFolder,
  'tabler:gift': TablerGift,
  'tabler:history': TablerHistory,
  'tabler:home': TablerHome,
  'tabler:home-2': TablerHome2,
  'tabler:inbox': TablerInbox,
  'tabler:language': TablerLanguage,
  'tabler:leaf': TablerLeaf,
  'tabler:list-check': TablerListCheck,
  'tabler:list-details': TablerListDetails,
  'tabler:mail': TablerMail,
  'tabler:map-pin': TablerMapPin,
  'tabler:message-chatbot': TablerMessageChatbot,
  'tabler:moneybag': TablerMoneybag,
  'tabler:moon': TablerMoon,
  'tabler:notebook': TablerNotebook,
  'tabler:package': TablerPackage,
  'tabler:plus': TablerPlus,
  'tabler:receipt': TablerReceipt,
  'tabler:report': TablerReport,
  'tabler:robot': TablerRobot,
  'tabler:selector': TablerSelector,
  'tabler:settings': TablerSettings,
  'tabler:shield-lock': TablerShieldLock,
  'tabler:ship': TablerShip,
  'tabler:sun': TablerSun,
  'tabler:tag': TablerTag,
  'tabler:template': TablerTemplate,
  'tabler:timeline-event': TablerTimelineEvent,
  'tabler:tool': TablerTool,
  'tabler:trending-up': TablerTrendingUp,
  'tabler:truck-delivery': TablerTruckDelivery,
  'tabler:users': TablerUsers,
  'tabler:users-group': TablerUsersGroup,
  'tabler:wallet': TablerWallet,
  'tabler:world': TablerWorld,
  'tabler:world-dollar': TablerWorldDollar,
};

export type SidebarIconName = keyof typeof sidebarIcons;

type SidebarIconProps = Omit<IconProps, 'icon'> & {
  icon: SidebarIconName;
};

export const SidebarIcon = ({ icon, ...props }: SidebarIconProps) => (
  <Icon {...props} icon={sidebarIcons[icon]} />
);
